import React from 'react';

const LoadingIndicator: React.FC = () => (
  <div className="flex justify-center items-center h-full">
    <span className="loading loading-spinner loading-lg"></span>
  </div>
);

export default LoadingIndicator;
